import { useContext } from 'react';
import PropTypes from 'prop-types';

import { FormStepContext } from '../stages/FormStepContext';

const ButtonNext = ({ stepId, isDisabled, buttonId }) => {
  const { setStep } = useContext(FormStepContext);

  const onSetNextStep = () => {
    setStep(stepId + 1);
  };

  return (
    <button
      type="button"
      className="primaryFatLink ic-arrow-left"
      id={buttonId}
      onClick={onSetNextStep}
      disabled={isDisabled}
    >
      {stepId === 5 ? 'Submit' : 'Next Step'}
    </button>
  );
};

export default ButtonNext;

ButtonNext.propTypes = {
  stepId: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool,
};
